<div class="ui-g-12">

    <kv-search-toolbar
            [dateBoxEnabled]="true"
            [date_structure]="searchModel.date_structure"
            [card_modes]="searchModel.card_modes"
            [clusters]="searchModel.cluster_list"
            [customersBoxEnabled]="false"
            [clusterFieldEnabled]="false"
            [selectedElapsedStart]="searchModel.selectedStartDate"
            [selectedElapsedEnd]="searchModel.selectedEndDate"
            [group_types]="searchModel.group_types"
            [groups]="searchModel.groups"
            [areas]="searchModel.areas"
            [stores]="searchModel.stores"
            [disableMutualExclusivity]="false"
            [storeSelectionMode]="'single'"
            [groupTypesFieldEnabled]="false"
            [areaFieldEnabled]="false"
            [groupFieldEnabled]="false"
            appQFilter
            (onQFilter)="searchValueTrend($event)"
    ></kv-search-toolbar>
    <div class="ui-g">
        <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
            <app-infobox [pointData]="indicator.pointData" [penetration]="indicator.penetration" [t]="indicator.t" [options]="indicator.options"></app-infobox>
        </div>
    </div>

    <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
        <h3>{{ translations.fatturato }}</h3>
        <div class="chart-container">
            <chart [options]="invoicePolar.options"
                   (load)="setChartInstance(invoicePolar, $event.context)"></chart>
        </div>
    </div>

    <div class="ui-g-12 ui-md-6 ui-sm-12"  *ngIf="data != null">
        <h3>{{ translations.articoli_assortimento }}</h3>
        <div class="chart-container">
            <chart [options]="productPolar.options"
                   (load)="setChartInstance(productPolar, $event.context)"></chart>
        </div>
    </div>

    <p-dialog header="Error" [(visible)]="storeError" [width]="300" [modal]="true" [draggable]="false" [resizable]="false">
        <p>{{ selectOneError }}</p>
        <div class="ui-dialog-footer">
            <button pButton type="button" class="slim red-button" (click)="toogleErrorStoreDialog()" label="Ok"></button>
        </div>
    </p-dialog>

</div>



// WEBPACK FOOTER //
// ./src/app/views/store/assortimento/assortimento-main-kpi/assortimento-main-kpi.component.html